export default __webpack_public_path__ + "static/media/Test_Creation.8df8b418.svg";